import { useTranslation } from "react-i18next";

import { Button } from "src/core/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "src/core/components/ui/dialog";

type DeleteFolderModalViewProps = {
  open: boolean;
  loading: boolean;
  onConfirm: () => void;
  onClose: () => void;
};

export const DeleteFolderModalView: React.FC<DeleteFolderModalViewProps> = ({
  open,
  loading,
  onConfirm,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (loading) return;
        if (!nextOpen) onClose();
      }}
    >
      <DialogContent hideCloseButton onInteractOutside={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle>{t("folder.deleteFolder.title")}</DialogTitle>
        </DialogHeader>
        <DialogDescription className="whitespace-pre-wrap">
          {t("folder.deleteFolder.description")}
        </DialogDescription>
        <DialogFooter className="gap-x-10">
          <Button onClick={onConfirm} loading={loading} data-testid="confirm-delete-folder">
            {t("folder.deleteFolder.confirm")}
          </Button>
          <Button variant="link" onClick={onClose} disabled={loading}>
            {t("global.form.cancel")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
